import { gql } from '@apollo/client';

export const JOB_EXPORTS_QUERY = gql`
  query bulkExport {
    bulkExport {
      listJobs {
        id
        completionPercent
        createdBy
        createdTimestamp
        status
        query
        label
        s3Bucket
        filenamePrefix
        recipients
        timeRange {
          min
          max
        }
        output
      }
    }
  }
`;

export const EXPORT_JOB_MUTATION = gql`
  mutation exportJob($job: BulkExportRequestInput) {
    addJob(job: $job) {
      id
    }
  }
`;

export const CANCEL_JOB_MUTATION = gql`
  mutation cancelJob($jobId: String) {
    cancelJob(jobId: $jobId) {
      id
    }
  }
`;
